// Cálculo de tempo de curso/carreira a partir de uma única data-marco.
// 100% client-side (Date nativo), sem backend, API ou persistência:
// tudo é recalculado a cada carregamento da página.

const MONTHS_PER_SEMESTER = 6;

// 'YYYY-MM-DD' -> Date no fuso local.
// (new Date('2024-02-01') seria interpretado como UTC e pode voltar um dia.)
function toDate(value) {
  if (value instanceof Date) return value;
  const [year, month, day] = String(value).split('-').map(Number);
  return new Date(year, (month || 1) - 1, day || 1);
}

// Meses completos decorridos entre a data-marco e agora.
function monthsElapsed(startDate, now) {
  const start = toDate(startDate);
  const end = toDate(now);
  let months =
    (end.getFullYear() - start.getFullYear()) * 12 +
    (end.getMonth() - start.getMonth());

  if (end.getDate() < start.getDate()) {
    months -= 1;
  }

  return Math.max(0, months);
}

// Anos completos desde a data-marco (arredondado para baixo).
export function getYearsSince(startDate, now = new Date()) {
  return Math.floor(monthsElapsed(startDate, now) / 12);
}

// Período/semestre atual: incrementa 1 a cada 6 meses corridos desde a data-marco.
// Com marco em fev/2024 isso acompanha o calendário acadêmico:
// fev-jun 2024 = 1º, ago-dez 2024 = 2º, fev-jun 2025 = 3º, e assim por diante.
export function getCurrentSemester(startDate, now = new Date()) {
  return Math.floor(monthsElapsed(startDate, now) / MONTHS_PER_SEMESTER) + 1;
}

export function formatOrdinal(value, language) {
  if (language === 'pt') {
    return `${value}º`;
  }

  const suffixes = ['th', 'st', 'nd', 'rd'];
  const mod100 = value % 100;
  return `${value}${suffixes[(mod100 - 20) % 10] || suffixes[mod100] || suffixes[0]}`;
}

// '5º período' / '5th semester'
export function formatSemester(startDate, language, now = new Date()) {
  const semester = getCurrentSemester(startDate, now);
  return language === 'pt'
    ? `${formatOrdinal(semester, 'pt')} período`
    : `${formatOrdinal(semester, 'en')} semester`;
}

// 'Ano' / 'Anos' / 'Year' / 'Years'
export function yearsWord(years, language) {
  if (language === 'pt') {
    return years === 1 ? 'Ano' : 'Anos';
  }
  return years === 1 ? 'Year' : 'Years';
}